import { Image } from "#/api/fileStore.type";
import { MessageRow } from "../../api/message.type";
import Typography from "../shared/typography";
import { formatTimeStampToHumanReadableDateTimeSeconds } from "../utls/time";
import { cn, getMimeTypeFromExtension } from "../utls/utils";
import { ImageCarousel } from "./image-carousel";

type UserChatItemProps = {
  message: MessageRow;
  align?: "start" | "end"; // controls horizontal alignment of the bubble within its row
};

function UserChatItem({ message, align = "end" }: UserChatItemProps) {
  // Transform message_file_store data to the format expected by ImageCarousel
  const images =
    message?.message_file_store?.map((fs) => ({
      url: fs.file_store.url,
      fileName: fs.file_store.name,
      fileType: getMimeTypeFromExtension(fs.file_store.name || ""),
    })) || [];

  const hasImages = images.length > 0;

  return (
    <div
      className={cn(
        "flex items-start",
        align === "end" ? "justify-end" : "justify-start"
      )}
    >
      <div
        className={cn(
          "lg:max-w-full max-w-[90%] rounded-lg p-4",
          "bg-terracotta-500 text-white", // Updated to use the Harper brand color
          "shadow-sm"
        )}
      >
        {/* Display text content if any */}
        {message.content && (
          <Typography variant="body1" className="text-white">
            {message.content}
          </Typography>
        )}

        {/* Display image carousel if there are images */}
        {hasImages && (
          <div
            className={cn(
              "mt-3",
              message.content ? "pt-2 border-t border-terracotta-400" : ""
            )}
          >
            <ImageCarousel size="small" images={images as Image[]} />
          </div>
        )}

        {/* Timestamp */}
        <Typography
          variant="caption"
          className="text-terracotta-200 mt-2 block text-right"
        >
          {formatTimeStampToHumanReadableDateTimeSeconds(message.created_at)}
        </Typography>
      </div>
    </div>
  );
}

export default UserChatItem;
